import * as React from "react";

const CloudDownloadIcon = (props) => (
	<svg
		width={24}
		height={25}
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12 9.089v6m0 0 3-2m-3 2-3-2m14 2a4 4 0 0 0-4.07-4A7.002 7.002 0 0 0 5.669 9.1 5 5 0 0 0 6 19.09h13a4 4 0 0 0 4-4"
			stroke={props.stroke}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CloudDownloadIcon;
